<template>
  <div class="paddingTop50">
    <div class="back" :style="{ backgroundColor: color }">
      <div
        :style="{ pointerEvents: isPrev ? 'auto' : 'none' }"
        style="align-content: center; text-align: left; height: 100%; width: 25%"
        @click="handler()"
      >
        <slot name="left_icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m11.32 11.979 3.4-3.36a.943.943 0 0 0-.312-1.546.97.97 0 0 0-1.051.208l-4.073 4.024A.949.949 0 0 0 9 11.98a.94.94 0 0 0 .284.674l4.073 4.072a.96.96 0 0 0 .682.275.97.97 0 0 0 .682-.275.943.943 0 0 0 0-1.339l-3.4-3.407z"
              fill="#fff"
            />
          </svg>
        </slot>
      </div>
      <div class="title1" style="align-content: center; height: 100%; width: 50%">
        <slot name="title">
          {{ title }}
        </slot>
      </div>
      <div class="" style="align-content: center; text-align: right; height: 100%; width: 25%">
        <slot name="right_icon">
          <img
            style="pointer-events: none; opacity: 0"
            src="../assets/images/ic24ArrowL.svg"
            alt=""
          />
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavBar',
  props: {
    title: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    isPrev: {
      type: Boolean,
      default: true,
    }
  },
  data: () => ({}),
  mounted() {
    this.getWindow()
  },
  methods: {
    getWindow() {
      const back = document.querySelector('.back')
      back.style.backgroundColor = 'transparent'

      window.addEventListener('scroll', () => {
        if (window.scrollY > 0) {
          back.style.backgroundColor = this.color
        } else {
          back.style.backgroundColor = 'transparent'
        }
      })
    },
    handler() {
      if (this.url == '') this.$router.go(-1)
      else this.$router.push(this.url)
    },
  },
}
</script>

<style lang="scss" scoped>
.title1 {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  line-height: 21.6px;
  letter-spacing: 4%;
  font-size: 18px;
  color: #fff;
}
.back {
  display: flex;
  height: 60px;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 0px 20px 0px 16px;
  background-size: cover;
  background-position-y: top;
  position: fixed;
  left: 0;
  top: 0px;
  z-index: 2;
  > img {
    height: 31px;
    margin-left: -6px;
  }

  a {
    &.save,
    &.delete {
      flex: 1;
      text-align: right;
    }
  }
}
.paddingTop50 {
  padding-top: 60px;
  width: 100%;
}
</style>
